/// <reference path="../types.d.ts" />
import { cmxLocation, appServiceLines } from '@codametrix/ui-common';
import history from '../history';
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { ServiceLine } from './action-types';
import { applyDefaultFilters, clearAllFilters } from './cases.action';
import { getEula, saveEula } from './eula';
import { navigateContext } from './ui';
import { fetchTableauToken } from './analytics';
const saveServiceLine = createAction(ServiceLine.SAVE_SERVICE_LINE);
const chooseServiceLine = createAsyncThunk(ServiceLine.CHOOSE_SERVICE_LINE, async (payload, { dispatch, getState, rejectWithValue })=>{
    const { serviceLine, context, homepagePreference } = payload;
    dispatch(saveServiceLine(serviceLine));
    const location = cmxLocation.getLocation();
    if (location === '/eula/') {
        const eulaUpToDate = await getEula(context.user.id || -1, context.activeContext?.organizationId || -1);
        dispatch(saveEula(eulaUpToDate));
        history.push(location);
        return;
    }
    dispatch(navigateContext({
        context,
        homepagePreference
    }));
});
const navigateServiceLine = createAsyncThunk(ServiceLine.NAVIGATE_SERVICE_LINE, async (payload, { dispatch, getState, rejectWithValue })=>{
    const { choice, context, actionGroups } = payload;
    dispatch(saveServiceLine(choice));
    dispatch(clearAllFilters());
    dispatch(applyDefaultFilters(context));
    if (actionGroups.find((ag)=>ag.options[0].active === true)?.key === 'cases') {
        history.replace(`/cmx/cases/${appServiceLines.toServiceLineSlug(choice.name)}/`);
    } else if (actionGroups.find((ag)=>ag.options[0].active === true)?.key === 'tableau-dashboard') {
        dispatch(fetchTableauToken(choice));
        history.push('/cmx/tableau/');
    }
});
export { chooseServiceLine, saveServiceLine, navigateServiceLine };
